import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanyLogoService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetProfileImage = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto | undefined,
  unknown
> => {
  const ProfileImage = useQuery(
    ['getProfileImage'],
    async () => {
      return await handleRequest(CompanyLogoService.getApiCustomerApiAppCompanyLogoCompanyLogo());
    },
    {
      keepPreviousData: true,
      cacheTime: 1000 * 60 * 5,
    }
  );

  return ProfileImage;
};

export default useGetProfileImage;
